/* @/utils/notification.utils.ts */

export function getNotificationTranslationId(actionType: string): string {
  const actionDictionary: Record<string, string> = {
    PURCHASE: "main.headerNotifications.purchase",
    SALE: "main.headerNotifications.sale",
    VESTING: "main.headerNotifications.vesting",
    OUTGOING: "main.headerNotifications.outgoing",
    INCOMING: "main.headerNotifications.incoming",
    GFAL_SALE: "main.headerNotifications.GFAL_sale",
    GFAL_PURCHASE: "main.headerNotifications.GFAL_purchase",
    REWARD: "main.headerNotifications.reward",
    COLLECTIBLE_SALE: "main.headerNotifications.collectible_sale",
    PENDING_OFFER: "main.headerNotifications.pending_offer",
    BUYER_CANCELLED_OFFER: "main.headerNotifications.rejected_offer",
    SELLER_CANCELLED_OFFER: "main.headerNotifications.rejected_offer",
    SENDED_ACCEPTED_OFFER: "main.headerNotifications.accepted_offer",
    SENT_ACCEPTED_OFFER: "main.headerNotifications.accepted_offer",
    EXPIRED_OFFER: "main.headerNotifications.expired_offer",
    EXPIRING_SOON_OFFER: "main.headerNotifications.expiring_offer",
    STREAK_REMINDER: "main.headerNotifications.streak_reminder",
    STREAK_INCREASE: "main.headerNotifications.streak_increase",
    CRAFT_AVAILABLE: "main.headerNotifications.craft_available",
  };
  return actionDictionary[actionType];
}

export const isStreakNotificationType = (type: string) => {
  const streakTypes = ["STREAK_REMINDER", "STREAK_INCREASE"];
  return streakTypes.includes(type);
};

export const isRampNotificationType = (type: string) => {
  const rampTypes = ["GFAL_SALE", "GFAL_PURCHASE"];
  return rampTypes.includes(type);
};

export function getRampNotificationTranslationId(
  actionType: string,
  status: string
): string {
  const GFALStatusDictionary: Record<string, Record<string, string>> = {
    GFAL_PURCHASE: {
      FAILED: "main.headerNotifications.purchaseFailed",
      PENDING: "main.headerNotifications.purchasePending",
      RAMP_PENDING: "main.headerNotifications.purchasePending",
      COMPLETE: "main.headerNotifications.purchaseCompleted",
    },
    GFAL_SALE: {
      FAILED: "main.headerNotifications.saleFailed",
      PENDING: "main.headerNotifications.salePending",
      RAMP_PENDING: "main.headerNotifications.salePending",
      COMPLETE: "main.headerNotifications.saleCompleted",
    },
  };
  return GFALStatusDictionary[actionType][status];
}

export const isActivityRoutingType = (type: string) => {
  const activityTypes = [
    "PURCHASE",
    "SALE",
    "VESTING",
    "INCOMING",
    "OUTGOING",
    "GFAL_SALE",
    "GFAL_PURCHASE",
    "COLLECTIBLE_SALE",
    "COLLECTIBLE_PURCHASE",
  ];
  return activityTypes.includes(type);
};

export const isOfferRoutingType = (type: string) => {
  const offerTypes = ["PENDING_OFFER"];
  return offerTypes.includes(type);
};

export const isCollectibleRoutingType = (type: string) => {
  const collectibleTypes = [
    "EXPIRING_SOON_OFFER",
    "EXPIRED_OFFER",
    "SENT_ACCEPTED_OFFER",
    "RECEIVED_ACCEPTED_OFFER",
    "BUYER_CANCELLED_OFFER",
    "SELLER_CANCELLED_OFFER",
    "REWARD",
    "MINT",
  ];
  return collectibleTypes.includes(type);
};

export const isCraftableRoutingType = (type: string) => {
  const craftableTypes = ["CRAFT_AVAILABLE"];
  return craftableTypes.includes(type);
};

export const isCraftableNotificationType = (type: string) => {
  const craftableTypes = ["CRAFT_AVAILABLE"];
  return craftableTypes.includes(type);
};

export const isMonetaryNotification = (type: string) => {
  const monetaryNotificationsType = [
    "PURCHASE",
    "SALE",
    "VESTING",
    "INCOMING",
    "OUTGOING",
    "GFAL_SALE",
    "GFAL_PURCHASE",
  ];
  return monetaryNotificationsType.includes(type);
};
